(function(){
  function root(){
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function findProduct(id){
    var list=window.NH_SHOPIFY_PRODUCTS||[];
    for(var i=0;i<list.length;i++){
      if(String(list[i].id)===String(id))return list[i];
    }
    return null;
  }

  function moneyFromCents(cents){
    var n=Number(cents||0)/100;
    return 'R$ '+n.toFixed(2).replace('.',',');
  }

  function normalizeSizeLabel(value){
    return String(value||'').replace(/\s+/g,' ').trim().replace(/ml\b/i,'ml');
  }

  function renderEmptyCartState(){
    var wrap=document.getElementById('cart-items');
    if(wrap){
      wrap.innerHTML='<div class="cart-empty"><b style="font-size:17px;color:var(--ink)">Seu carrinho está vazio</b><span style="max-width:260px;line-height:1.5">Adicione seus produtos favoritos para continuar a compra.</span><button class="btn" type="button" onclick="closeCart()">Explorar produtos</button></div>';
    }
    var title=document.getElementById('cart-title');
    if(title)title.textContent='Seu carrinho';
    var progress=document.getElementById('cart-progress');
    if(progress)progress.innerHTML='';
    var subtotal=document.getElementById('cart-subtotal');
    if(subtotal)subtotal.textContent='R$ 0,00';
    var total=document.getElementById('cart-total');
    if(total)total.textContent='R$ 0,00';
  }

  function refreshCartBadge(){
    var badge=document.getElementById('cart-count');
    if(!badge)return;
    badge.style.display='none';
    fetch(root()+'cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(cart){
        var count=Number(cart.item_count||0);
        badge.textContent=count;
        badge.style.display=count>0?'flex':'none';
        if(count===0)renderEmptyCartState();
      })
      .catch(function(){});
  }

  function ensureQtyStyles(){
    if(document.getElementById('nh-cart-qty-hotfix'))return;
    var style=document.createElement('style');
    style.id='nh-cart-qty-hotfix';
    style.textContent='\
      .citem .cinfo{display:flex!important;flex-direction:column!important;align-items:flex-start!important;justify-content:flex-start!important;min-width:0!important;}\
      .citem .cinfo>b,.citem .cinfo>small{display:block!important;width:100%!important;}\
      .cqty{display:inline-flex!important;align-items:center!important;gap:0!important;border:1px solid var(--line)!important;border-radius:var(--r)!important;margin-top:12px!important;overflow:hidden!important;background:#fff!important;width:auto!important;align-self:flex-start!important;}\
      .cqty button{width:32px!important;height:30px!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:0!important;margin:0!important;line-height:1!important;font-size:17px!important;color:var(--ink)!important;background:#fff!important;border:0!important;}\
      .cqty button:hover{background:var(--fill)!important;}\
      .cqty span{width:34px!important;height:30px!important;display:flex!important;align-items:center!important;justify-content:center!important;border-left:1px solid var(--line)!important;border-right:1px solid var(--line)!important;font-size:13px!important;font-weight:700!important;line-height:1!important;}\
      .cart-empty{min-height:280px!important;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:10px!important;text-align:center!important;padding:36px 20px!important;}\
      #pdp-sizes .variant[data-shopify-variant]{cursor:pointer;}';
    document.head.appendChild(style);
  }

  /* ================= VARIANTES REAIS SHOPIFY ================= */
  var currentPdpId=null;
  var currentPdpVariant=null;
  var variantLoadToken=0;
  var productJsonCache={};

  function optionName(option){
    if(typeof option==='string')return option;
    return option && option.name ? option.name : '';
  }

  function getSizeOptionIndex(product){
    var opts=product && product.options ? product.options : [];
    for(var i=0;i<opts.length;i++){
      var name=optionName(opts[i]).toLowerCase();
      if(name.indexOf('tamanho')>-1 || name.indexOf('volume')>-1 || name==='size')return i;
    }
    if(product && product.variants && product.variants.length>1 && opts.length===1)return 0;
    return -1;
  }

  function variantOptionValue(variant,index){
    if(!variant)return '';
    if(Array.isArray(variant.options) && variant.options[index]!=null)return variant.options[index];
    var key='option'+(index+1);
    if(variant[key]!=null)return variant[key];
    return variant.title||'';
  }

  function getInternalProduct(id){
    try{
      if(typeof byId==='function')return byId(id);
    }catch(e){}
    return null;
  }

  function applyVariantToProduct(id,variant,label){
    var raw=findProduct(id);
    var internal=getInternalProduct(id);
    var price=Number(variant.price||0)/100;
    var compare=variant.compare_at_price==null?null:Number(variant.compare_at_price)/100;
    var targets=[raw,internal];
    for(var i=0;i<targets.length;i++){
      var p=targets[i];
      if(!p)continue;
      p.variantId=variant.id;
      p.priceCents=Number(variant.price||0);
      p.compareAtCents=variant.compare_at_price==null?null:Number(variant.compare_at_price);
      p.price=price;
      p.old=(compare && compare>price)?compare:null;
      p.vol=label;
      p.available=variant.available!==false;
    }
  }

  function updateVolumeInDetails(label){
    var rows=document.querySelectorAll('#pdp-tab-desc .info-list > div');
    rows.forEach(function(row){
      var cells=row.querySelectorAll('span');
      if(cells.length>1 && String(cells[0].textContent).trim().toLowerCase()==='volume'){
        cells[1].textContent=label;
      }
    });
  }

  function updatePdpForVariant(id,variant,sizeIndex){
    if(!variant)return;
    var p=findProduct(id);
    if(!p)return;
    var label=normalizeSizeLabel(variantOptionValue(variant,sizeIndex));
    currentPdpId=id;
    currentPdpVariant=variant;
    applyVariantToProduct(id,variant,label);

    var price=document.getElementById('pdp-price');
    if(price)price.textContent=moneyFromCents(variant.price);

    var old=document.getElementById('pdp-old');
    if(old){
      var compare=Number(variant.compare_at_price||0);
      var actual=Number(variant.price||0);
      old.textContent=compare>actual?moneyFromCents(compare):'';
    }

    var title=document.getElementById('pdp-title');
    if(title){
      var base=String(p.name||'').replace(/\s*[—-]\s*\d+\s*ml\s*$/i,'').trim();
      title.textContent=base+(label?' — '+label:'');
    }

    updateVolumeInDetails(label);

    document.querySelectorAll('#pdp-sizes .variant[data-shopify-variant]').forEach(function(el){
      el.classList.toggle('on',String(el.getAttribute('data-shopify-variant'))===String(variant.id));
    });

    var variantImage=variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
    if(variantImage){
      var main=document.querySelector('#pdp-main img, #pdp-main-img, .gallery .main img');
      if(main && main.tagName==='IMG')main.src=variantImage;
    }
  }

  window.selectPdpShopifyVariant=function(variantId){
    if(!currentPdpId)return;
    var p=findProduct(currentPdpId);
    if(!p || !p.__shopifyProductJson)return;
    var product=p.__shopifyProductJson;
    var variant=(product.variants||[]).find(function(v){return String(v.id)===String(variantId);});
    if(!variant)return;
    updatePdpForVariant(currentPdpId,variant,getSizeOptionIndex(product));
  };

  function fetchProductJson(p){
    if(!p || !p.handle)return Promise.reject(new Error('Produto sem handle'));
    if(productJsonCache[p.handle])return Promise.resolve(productJsonCache[p.handle]);
    return fetch(root()+'products/'+encodeURIComponent(p.handle)+'.js',{credentials:'same-origin'})
      .then(function(r){
        if(!r.ok)throw new Error('Falha ao carregar variantes');
        return r.json();
      })
      .then(function(product){
        productJsonCache[p.handle]=product;
        return product;
      });
  }

  function syncPdpVariants(id){
    var p=findProduct(id);
    if(!p || !p.handle)return;
    var token=++variantLoadToken;

    fetchProductJson(p).then(function(product){
      if(token!==variantLoadToken)return;
      var variants=product.variants||[];
      var sizeIndex=getSizeOptionIndex(product);
      if(!variants.length || sizeIndex<0)return;

      p.__shopifyProductJson=product;
      var internal=getInternalProduct(id);
      if(internal)internal.__shopifyProductJson=product;

      var unique=[];
      var seen={};
      variants.forEach(function(v){
        var label=normalizeSizeLabel(variantOptionValue(v,sizeIndex));
        if(!label || label.toLowerCase()==='default title' || seen[label.toLowerCase()])return;
        seen[label.toLowerCase()]=true;
        unique.push({label:label,variant:v});
      });
      if(!unique.length)return;

      var sizes=document.getElementById('pdp-sizes');
      if(sizes){
        sizes.innerHTML=unique.map(function(item){
          return '<span class="variant" data-shopify-variant="'+item.variant.id+'" onclick="selectPdpShopifyVariant(\''+item.variant.id+'\')">'+item.label+'</span>';
        }).join('');
      }

      /* A primeira variante cadastrada na Shopify vira a seleção inicial.
         Assim título, preço e botão usam exatamente a mesma variante do admin. */
      var initial=variants[0];
      updatePdpForVariant(id,initial,sizeIndex);
    }).catch(function(err){
      console.warn('[Natural Health] Não foi possível carregar variantes Shopify:',err);
    });
  }

  function selectedVariantIdFor(id){
    if(String(currentPdpId)===String(id) && currentPdpVariant && currentPdpVariant.id)return currentPdpVariant.id;
    var p=findProduct(id);
    return p && p.variantId ? p.variantId : null;
  }

  function directCheckout(id,qty){
    qty=Math.max(1,Number(qty)||1);
    var variantId=selectedVariantIdFor(id);
    if(!variantId)return;
    window.location.href=root()+'cart/'+encodeURIComponent(variantId)+':'+qty+'?checkout';
  }

  function applyOverrides(){
    ensureQtyStyles();
    refreshCartBadge();

    var originalOpenProduct=window.openProduct;
    window.openProduct=function(id,noNav){
      currentPdpId=id;
      currentPdpVariant=null;
      var result;
      if(typeof originalOpenProduct==='function')result=originalOpenProduct.apply(this,arguments);
      syncPdpVariants(id);
      return result;
    };

    window.buyNow=function(id,qty){
      directCheckout(id,qty);
    };

    window.addPdp=function(buy){
      if(typeof pdpId==='undefined' || !pdpId)return;
      var qty=(typeof pdpQty==='undefined')?1:pdpQty;
      if(buy){
        directCheckout(pdpId,qty);
        return;
      }

      /* addToCart usa byId(); o produto interno já foi atualizado com a variante selecionada. */
      if(typeof addToCart==='function')addToCart(pdpId,qty);
    };

    var originalOpenCart=window.openCart;
    window.openCart=function(){
      renderEmptyCartState();
      if(typeof originalOpenCart==='function')originalOpenCart.apply(this,arguments);

      fetch(root()+'cart.js',{credentials:'same-origin'})
        .then(function(r){return r.json();})
        .then(function(cart){
          if(Number(cart.item_count||0)===0){
            renderEmptyCartState();
          }else if(typeof syncCart==='function'){
            syncCart();
          }
        })
        .catch(function(){renderEmptyCartState();});
    };

    /* Se a página de produto já foi aberta pelo script principal antes deste hotfix carregar. */
    try{
      if(typeof pdpId!=='undefined' && pdpId){
        currentPdpId=pdpId;
        syncPdpVariants(pdpId);
      }else{
        var match=location.pathname.match(/\/products\/([^\/?#]+)/i);
        if(match){
          var handle=decodeURIComponent(match[1]);
          var product=(window.NH_SHOPIFY_PRODUCTS||[]).find(function(item){return item.handle===handle;});
          if(product){currentPdpId=product.id;syncPdpVariants(product.id);}
        }
      }
    }catch(e){}
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',applyOverrides);
  }else{
    applyOverrides();
  }
})();
